import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import careImg1 from "../assets/images/care01.png";
import careImg2 from "../assets/images/care02.png";
import careImg3 from "../assets/images/care03.png";

import Box from '@mui/material/Box';
import Bottom from "./Bottom";
import CareHomeTop from "../components/top/CareHomeTop";
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useEffect } from "react";
import api from "../utils/api";
import * as util from "../utils/util";
import { goLoginAndReturn } from "../utils/loginRedirect";

import Stack from '@mui/material/Stack';
import ButtonBase from '@mui/material/ButtonBase';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';

import MainNews from "../components/main/MainNews";

import caretopimg1 from "../assets/images/care1.png";
import caretopimg2 from "../assets/images/care2.png";
import caretopimg3 from "../assets/images/care3.png";
import careStore from "../store/careStore";


const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const Care = () => {
  const navigate = useNavigate();
  const [existPlan, setExistPlan] = React.useState(false);
  const storeData1: any = careStore();
  
  useEffect(() => {
    
    return () => {
      storeData1.setCareInfo('height', 0);
      storeData1.setCareInfo('weight', 0);
      storeData1.setCareInfo('reset', '');
    }
  }, []);

  useEffect(() => {

    if (util.strNull(window.localStorage.userCusID) !== '') {
      // 맞춤플랜 존재/미존재 확인
      api.get(`app/api/v1/AP_004_002`).then(res => {
        const planCode = res.data.result_code;
        if (planCode === '0') { // 생성된 맞춤플랜 있음(7일 지나지 않음)
          setExistPlan(true);
        } else if (planCode === '100') {
          setExistPlan(false);
        }
      }).catch(function (error) {
        console.log(error)
      });
    }

  }, []);

  // 맞춤플랜 시작
  async function handleStartPlan() {
    navigate('/care/CareStep');
  }

  // 맞춤플랜 보기
  async function handleGetPlan() {
    navigate('/care/CareMenu');
  }


  // 새로고침 이미지 변경
  const ImgArr = [careImg1, careImg2, careImg3];
  const randomIndex = Math.floor(Math.random() * ImgArr.length);
  const careImg = ImgArr[randomIndex];

  // 새로고침 이미지 변경
  const ImageArr = [caretopimg1, caretopimg2, caretopimg3];
  const randomImg = Math.floor(Math.random() * ImageArr.length);
  const careTopImg = ImageArr[randomImg];



  return (


    <Container sx={{ p: '0 !important', bgcolor: '#F6F6F6', pb: '10px !important', minWidth: 320 }}>
      {/* <CareHomeTop /> */}

      <Box sx={{ bgcolor: '#efdffb', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, minWidth: 320 }} >
        {/* logo */}
        <Box position={'fixed'} width={'100%'} bgcolor={'#efdffb'} zIndex={999}  maxWidth={'1200px'}>
          <Stack direction={'row'} >
            <Box>
              <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                <Img alt="Dual" src="/dual.png" />
              </ButtonBase>
            </Box>
          </Stack>
        </Box>

        <Grid container spacing={2} direction='row' sx={{ mt: 6 }}>

          <Grid container item xs sx={{ pl: 2 }} direction='column' justifyContent='center' alignContent={'center'}>
            <Typography sx={{ fontSize: '2.2rem', color: '#b658ef', fontWeight: 900, }}>
              맞춤케어
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#c462ff', fontWeight: 500, }} gutterBottom>
              건강서비스
            </Typography>
          </Grid>
          <Grid sx={{ width: '45%', mr: 1, pt: 0, pl: 0 }} justifyContent='center' alignContent={'center'}>
            <Img alt="care" src={careTopImg} />
          </Grid>
        </Grid>
      </Box>




      <Box sx={{ pl: 2, pr: 2 }}>
        <Box >
          <Typography sx={{ display: 'block', fontSize: '16px', color: '#444', p: '30px 0 0 0', textAlign: 'center' }}>
            <b>개인의 건강상태에 맞춘<br /> 권장 섭취 칼로리, 레시피, 운동 프로그램</b>을<br /> 제공해 드립니다.
          </Typography>
        </Box>

        <Stack justifyContent={'center'} alignContent={'center'} sx={{ m: 2, width: 250, ml: 'auto', mr: 'auto' }}>
          <Box sx={{ width: 250, ml: 'auto' }}>
            <Img alt="care" src={careImg} />
          </Box>
        </Stack>


        {util.strNull(window.localStorage.userCusID) === '' ? (

          <Box sx={BtnStyle}>
            <Button variant="contained" sx={BottomBtnStyle}
              onClick={() => goLoginAndReturn(navigate, '/care')}
            >
              로그인 후 이용해주세요.
            </Button>
          </Box>


        ) : (
          !existPlan ? (
            <Box sx={BtnStyle}>
              <Button variant="contained" sx={BottomBtnStyle}
                onClick={() => handleStartPlan()} >
                맞춤플랜 시작
              </Button>
            </Box>
          ) : (
            <Box sx={BtnStyle}>
              <Button variant="contained" sx={BottomBtnStyle}
                onClick={() => handleGetPlan()} >
                맞춤플랜 보기
              </Button>
            </Box>
          )
        )}
        <Box sx={{ m: '0 auto', textAlign: 'right', pb: 3 }}>
          <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#aaa', mb: 0.5 }}>출처 : 권장섭취량, 운동량, 영양성분, 칼로리계산, BMI 계산방법</Typography>
          <Typography sx={{ fontSize: 11, overflowWrap: 'break-word', ml: 1, color: '#aaa' }}>- 한국영양학회 : <a href="https://www.kns.or.kr/" title="한국영양학회" target='_blank' style={{ textDecoration: 'none', color: '#aaa', fontSize: 11 }}>https://www.kns.or.kr </a></Typography>
          <Typography sx={{ fontSize: 11, overflowWrap: 'break-word', ml: 1, color: '#aaa' }}>- 식품안전나라 : <a href="https://www.foodsafetykorea.go.kr/main.do" title="식품안전나라" target='_blank' style={{ textDecoration: 'none', color: '#aaa', fontSize: 11 }}>https://www.foodsafetykorea.go.kr </a></Typography>
          <Typography sx={{ fontSize: 11, overflowWrap: 'break-word', ml: 1, color: '#aaa' }}>- 질병관리청(국가건강정보포털) : <a href="https://health.kdca.go.kr/healthinfo/biz/health/main/mainPage/main.do" title="질병관리청" target='_blank' style={{ textDecoration: 'none', color: '#aaa', fontSize: 11 }}>https://health.kdca.go.kr</a></Typography>
        </Box>

      </Box>
      <Box sx={{ bgcolor: '#fff', p: 2, pt: 1, pb: 10 }}>
        <MainNews />
      </Box>

      <Bottom />

    </Container>

  );
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 3,
  boxSizing: 'border-box',
  pb: 3
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default Care;